import ApiService from '@services/api.service'
import { store } from '@state/store'

const TimeZoneService = {
  async getTimeZoneInfo(timeZoneNumber) {
    let response = await ApiService.get(
      '/TimeZones/UTC/Tech/' + timeZoneNumber
    ).catch((err) => {
      throw err
    })

    store.updateTimeZoneInfo(response.data)
  },
}

export default TimeZoneService
